import { useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { LoadingContext } from "../context/LoadingContext";
import styles from "./styles/Home.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { loginUser } from "../services/AuthService";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";

const LoginPage = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const loginError = params.get("loginError ");
  const toastShown = useRef({ loginError: false });
  const { startLoading, stopLoading } = useContext(LoadingContext);
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { getUser } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setMessage("Please enter both email and password.");
      return;
    }

    try {
      startLoading("overlay");
      const res = await loginUser(email, password);
      console.log("Login successful");
      await getUser();
      stopLoading("overlay");
      navigate("/home");
    } catch (error) {
      console.error("Login error:", error);

      if (error.status === 400 && error.code === "USER_NOT_FOUND") {
        toast.error("Incorrect email or password!");
      } else if (error.status === 401 && error.code === "USER_NOT_VERIFIED") {
        toast.error(
          "Account is not verified! Please check you email for a verification link to finish setting up your account."
        );
      } else {
        toast.error("Invalid login!");
      }
    } finally {
      stopLoading("overlay");
    }
  };

  useEffect(() => {
    if (loginError === "true" && !toastShown.current.loginError) {
      toast.error("Please create an account first!");
      toastShown.current.loginError = true;
    }
  }, [loginError]);

  return (
    <div className={`${styles.dashboard} ${styles.loginPage}`}>
      <h1>Login</h1>
      <form onSubmit={handleLogin} className={styles.loginForm}>
        <input
          className={styles.formInput}
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        ></input>
        <input
          className={styles.formInput}
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        ></input>
        <button type="submit" className={styles.submitButton}>
          Login
        </button>
      </form>
      <div className={styles.dividerContainer}>
        <hr className={styles.divider} />
        <p>or</p>
        <hr className={styles.divider} />
      </div>
      <button
        className={`${styles.secondaryBtn} ${styles.spotifyLogin}`}
        onClick={() => navigate("/signup")}
      >
        <FontAwesomeIcon icon={faCirclePlus} />
        Create Account
      </button>
    </div>
  );
};

export default LoginPage;
